import { homeColors } from "~/components/home/theme.ts";

export type TabIconName = "checkbox-marked-outline" | "format-list-bulleted" | "view-grid-outline" | "heart-outline";

export const TAB_SELECTED_TEXT_COLOR = homeColors.primaryStrong;
